import React from "react";
import { FormControl, FormItem, FormLabel, FormMessage } from "../../../../components/ui/form";
import { Input } from "../../../../components/ui/input";
import { Button } from "../../../../components/ui/button";
import { Cross2Icon } from "@radix-ui/react-icons";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  SelectSeparator,
} from "../../../../components/ui/select";
import { ControllerRenderProps } from "react-hook-form";
import { OutreachProgram } from "../../types/outreach";

interface ProgramTypeSelectProps {
  field: ControllerRenderProps<OutreachProgram, "type">;
  FormField: any;
}

export function ProgramTypeSelect({ field }: ProgramTypeSelectProps) {
  const [isAddingNew, setIsAddingNew] = React.useState(false);
  const [newType, setNewType] = React.useState("");

  const handleNewType = () => {
    if (newType.trim()) {
      field.onChange(newType.trim());
      setIsAddingNew(false);
      setNewType("");
    }
  };

  if (isAddingNew) {
    return (
      <FormItem className="space-y-1">
        <FormLabel>New Program Type</FormLabel>
        <div className="flex gap-2">
          <FormControl>
            <Input
              value={newType}
              onChange={(e) => setNewType(e.target.value)}
              placeholder="Enter program type"
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleNewType();
                } else if (e.key === 'Escape') {
                  setIsAddingNew(false);
                  setNewType("");
                }
              }}
            />
          </FormControl>
          <Button
            type="button"
            variant="outline"
            size="icon"
            onClick={() => {
              setIsAddingNew(false);
              setNewType("");
            }}
          >
            <Cross2Icon className="h-4 w-4" />
          </Button>
        </div>
        <p className="text-xs text-muted-foreground">
          Press Enter to save or X to cancel
        </p>
        <FormMessage />
      </FormItem>
    );
  }

  return (
    <FormItem>
      <FormLabel>Program Type</FormLabel>
      <Select
        onValueChange={(value) => {
          if (value === "new") {
            setIsAddingNew(true);
          } else {
            field.onChange(value);
          }
        }}
        value={field.value}
      >
        <FormControl>
          <SelectTrigger>
            <SelectValue placeholder="Select type" />
          </SelectTrigger>
        </FormControl>
        <SelectContent>
          <SelectItem value="health-screening">Health Screening</SelectItem>
          <SelectItem value="vaccination">Vaccination</SelectItem>
          <SelectItem value="education">Health Education</SelectItem>
          <SelectItem value="treatment">Treatment Camp</SelectItem>
          <SelectSeparator />
          <SelectItem value="new" className="text-primary">
            + Create new type
          </SelectItem>
        </SelectContent>
      </Select>
      <FormMessage />
    </FormItem>
  );
}
